import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

const initialDiscoverState = {
  discoverDetails: [],
  discoverLocationDetails: [],
  discoverLanguageDetails: [],
  discoverChannelDetails: [],
  pagination: {
    limit: 0,
    page: 0,
    totalItems: 0,
    totalPages: 0,
  },
};

export const fetchDiscoverData = createAsyncThunk(
  "discover/fetchDiscoverData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/swagger/inf_filter", payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const fetchDiscoverLocation = createAsyncThunk(
  "discover/fetchDiscoverLocation",
  async ({ payload, channelName }, { rejectWithValue }) => {
    try {
      // const response = await axiosInstance.post("/swagger/fetch_location", {payload});
      let url = "";
      if (channelName === "youtube") {
        url = "/swagger/fetch_location_youtube";
      } else if (channelName === "instagram") {
        url = "/swagger/fetch_location";
      } else if (channelName === "tiktok") {
        url = "/swagger/fetch_location_tiktok";
      }
      const response = await axiosInstance.post(url, { payload: payload });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const fetchDiscoverLanguage = createAsyncThunk(
  "discover/fetchDiscoverLanguage",
  async ({ payload, channelName }, { rejectWithValue }) => {
    try {
      // const response = await axiosInstance.post("/swagger/fetch_language", {payload});
      let url = "";

      if (channelName === "youtube") {
        url = "/swagger/fetch_language_youtube";
      } else if (channelName === "instagram") {
        url = "/swagger/fetch_language";
      } else if (channelName === "tiktok") {
        url = "/swagger/fetch_language_tiktok";
      }

      else {
        url = "/swagger/fetch_language";
      }
      const response = await axiosInstance.post(url, { payload: payload });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

export const fetchDiscoverChannelData = createAsyncThunk(
  "discover/fetchDiscoverChannelData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/swagger/inf_search?query=${payload?.query}&includeUnlockStatus=${payload?.includeUnlockStatus}`, payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);


export const fetchDiscoverProfileData = createAsyncThunk(
  "discover/fetchDiscoverProfileData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/swagger/inf_analytics_profile", payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  },
);

const discoverSlice = createSlice({
  name: "discover",
  initialState: {
    filterDiscoverData: { ...initialDiscoverState },
    discoverChannelDetails: { ...initialDiscoverState },
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDiscoverData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDiscoverData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.discoverDetails = action.payload;
      })
      .addCase(fetchDiscoverData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchDiscoverLocation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDiscoverLocation.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.discoverLocationDetails = action.payload;
      })
      .addCase(fetchDiscoverLocation.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchDiscoverLanguage.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDiscoverLanguage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.discoverLanguageDetails = action.payload;
      })
      .addCase(fetchDiscoverLanguage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchDiscoverChannelData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDiscoverChannelData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.discoverChannelDetails = action.payload;
      })
      .addCase(fetchDiscoverChannelData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(fetchDiscoverProfileData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDiscoverProfileData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.discoverProfileDetails = action.payload;
      })
      .addCase(fetchDiscoverProfileData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default discoverSlice.reducer;
